import { BatchToRestock } from 'src/features/restocking/RestockingTypes'
import { formatDateReplaceHour } from 'src/utils/formatDate'
import * as S from './RestockingBatchesTable.styles'

interface Props {
  batches: BatchToRestock[]
  color: string
  width?: string
}

const RestockingBatchesTable = ({ batches, color, width }: Props) => (
  <S.Table color={color} width={width} data-testid='restocking-batches-table-test-id'>
    <S.THead>
      <S.Tr>
        <S.Th color={color}>Nº Etiqueta</S.Th>
        <S.Th color={color}>Validade</S.Th>
        <S.Th color={color} style={{ paddingRight: '20px' }}>Qtd.</S.Th>
      </S.Tr>
    </S.THead>
    <S.TBody>
      {batches.map((batch) => (
        <S.Tr key={batch.idBatch}>
          <S.Td color={color}>
            {batch.batchNumber}
          </S.Td>
          <S.Td color={color}>
            {formatDateReplaceHour(new Date(batch.expirationDate))}
          </S.Td>
          <S.Td color={color}>
            {batch.quantity}
          </S.Td>
        </S.Tr>
      ))}
    </S.TBody>
  </S.Table>
)

export default RestockingBatchesTable
